// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modal-2ijdW";
var _4 = "container-X4L5f";
var _5 = "header-2q_2C";
var _6 = "table-2BXZ0";
var _7 = "tableHeader-3-Q0m";
var _8 = "tableRow-TdhRv";
var _9 = "error-1cWih";
var _a = "promoCodeIcon-22q7U";
var _b = "passengerColumnName-HvSOP";
var _c = "promoCodeColumnName-Mtbou";
var _d = "priceColumnName-d1gci";
var _e = "passengerColumn-2E7GV";
var _f = "promoCodeColumn-2u1vQ";
var _10 = "priceColumn-2ie7d";
var _11 = "errorText-3BriM";
var _12 = "total-2LX7w";
var _13 = "totalPriceContainer-3Dxvh";
var _14 = "totalPrice-1vr6B";
var _15 = "totalPriceWithDiscountLabel-YDdSy";
var _16 = "totalPriceWithDiscount-xJMOu";
var _17 = "flightPriceLabel-1lytk";
var _18 = "flightPrice-38wml";
var _19 = "addServicesPriceLabel-EnDLr";
var _1a = "addServicesPrice-2mffj";
var _1b = "notification-3T_wS";
var _1c = "notificationTitle-3tbHm";
var _1d = "buttons-3tVI1";
var _1e = "submit-3FJMy";
var _1f = "cancel-12aoo";
var _20 = "close-3T7IX";
var _21 = "promoCodeValue-2UsJm";
var _22 = "totalPriceWithDiscountWrapper-N_DRR";
var _23 = "flightPriceWrapper-2Dx6Y";
var _24 = "addServicesPriceWrapper-38Qg6";
var _25 = "toolbar-39-7j";
var _26 = "toolbarContinueButton-18LB_";
export { _1 as "__esModule", _2 as "mobile", _3 as "modal", _4 as "container", _5 as "header", _6 as "table", _7 as "tableHeader", _8 as "tableRow", _9 as "error", _a as "promoCodeIcon", _b as "passengerColumnName", _c as "promoCodeColumnName", _d as "priceColumnName", _e as "passengerColumn", _f as "promoCodeColumn", _10 as "priceColumn", _11 as "errorText", _12 as "total", _13 as "totalPriceContainer", _14 as "totalPrice", _15 as "totalPriceWithDiscountLabel", _16 as "totalPriceWithDiscount", _17 as "flightPriceLabel", _18 as "flightPrice", _19 as "addServicesPriceLabel", _1a as "addServicesPrice", _1b as "notification", _1c as "notificationTitle", _1d as "buttons", _1e as "submit", _1f as "cancel", _20 as "close", _21 as "promoCodeValue", _22 as "totalPriceWithDiscountWrapper", _23 as "flightPriceWrapper", _24 as "addServicesPriceWrapper", _25 as "toolbar", _26 as "toolbarContinueButton" }
export default { "__esModule": _1, "mobile": _2, "modal": _3, "container": _4, "header": _5, "table": _6, "tableHeader": _7, "tableRow": _8, "error": _9, "promoCodeIcon": _a, "passengerColumnName": _b, "promoCodeColumnName": _c, "priceColumnName": _d, "passengerColumn": _e, "promoCodeColumn": _f, "priceColumn": _10, "errorText": _11, "total": _12, "totalPriceContainer": _13, "totalPrice": _14, "totalPriceWithDiscountLabel": _15, "totalPriceWithDiscount": _16, "flightPriceLabel": _17, "flightPrice": _18, "addServicesPriceLabel": _19, "addServicesPrice": _1a, "notification": _1b, "notificationTitle": _1c, "buttons": _1d, "submit": _1e, "cancel": _1f, "close": _20, "promoCodeValue": _21, "totalPriceWithDiscountWrapper": _22, "flightPriceWrapper": _23, "addServicesPriceWrapper": _24, "toolbar": _25, "toolbarContinueButton": _26 }
